import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gpsTrackerSelectKey } from '@components/modals/CreateEditAssetTrackingModal/services/useGPSTrackerSelectQuery';
import type { IFormGPSTracker } from '@components/modals/CreateEditGpsTrackerModal/constants/schemaGpsTracker';

import { apiClient } from '@services/apiClient';

import { gpsAssetsKey } from './useGPSAssetsQuery';
import { gpsTrackerKey } from './useGPSTrackersQuery';

const gpsTrackerSaveFn = (data: IFormGPSTracker, gpsTrackerId?: number | string) => {
  if (gpsTrackerId) {
    return apiClient.put(`${APP_API_URL_V2}fsd/gps-tracker/${gpsTrackerId}`, data);
  }

  return apiClient.post(`${APP_API_URL_V2}fsd/gps-tracker`, data);
};

export const useGPSTrackerSaveMutation = ({ gpsTrackerId }: { gpsTrackerId?: number | string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IFormGPSTracker) => gpsTrackerSaveFn(data, gpsTrackerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [gpsTrackerKey({})[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsTrackerSelectKey()[0]] });

      if (gpsTrackerId) {
        queryClient.invalidateQueries({ queryKey: [gpsAssetsKey({})[0]] });
      }
    },
  });
};
